export default __webpack_public_path__ + "static/media/cheese_melt.b2838177.svg";